/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BrandTokenByCashTagRequest} from '@cash-web/protos/squareup/cash/local/v1/cash_app_local_web_service.pb'
import {BrandTokenByCashTagResponse} from '@cash-web/protos/squareup/cash/local/v1/cash_app_local_web_service.pb'


export const brandTokenByCashTag = (request: BrandTokenByCashTagRequest, options?: CashRequestOptions) => post<BrandTokenByCashTagRequest, BrandTokenByCashTagResponse>("/2.0/cash/brand-token-by-cash-tag", request, {...options, rejectOnError: true })